var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"featured-rewards-header"},[_c('img',{attrs:{"src":_vm.background,"alt":"test!"}}),(!_vm.isUserLogged)?_c('div',{staticClass:"featured-rewards-header-f"},[_c('a',{staticClass:"button btn_link btn_Register btn-tertiary",attrs:{"href":"/mylotto-rewards/my-account/register"}},[_vm._v("Register Now")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }